/** What the reel card and inspector need: report rows, collection items and bookmarks all fit. */
export interface InspectReel {
  pk: string;
  shortcode: string;
  thumbUrl: string | null;
  videoUrl?: string | null;
  videoSavedAt?: number | null;
  /** Decision 80: something a transcription can read (audio track or a video with sound); absent = judge by videoUrl. */
  transcribable?: boolean;
  /** Decision 80: the saved video has no sound (low quality); its sound is the separate audio track. */
  videoSilent?: boolean;
  outlierScore: number | null;
  viralityScore: number | null;
  postedAt: number | null;
  durationS: number | null;
  views: number | null;
  likes: number | null;
  likesHidden: boolean;
  comments: number | null;
  caption: string | null;
  hasTranscript: boolean;
  hook?: string | null;
  hookScript?: string | null;
  isPinned?: boolean;
  isCollab?: boolean;
  /** This org's just-scanned reel, still being verified (decision 75): not scored yet. */
  verifying?: boolean;
  isPaidPartnership?: boolean;
  ownerHandle?: string | null;
  /** Decision 91: the other party a collab names ("Collab with @handle"; collabLabel in @vw/core). */
  collabWith?: { igPk: string; handle: string | null } | null;
  audio?: { title: string | null; artist: string | null; type: 'original' | 'licensed' | null } | null;
}

export interface Transcript { text: string; script: string; lang: string; romanText: string | null; hook: string | null; needsReview?: boolean; pending?: boolean }

export const LANG: Record<string, string> = {
  en: 'English', hi: 'Hindi', hinglish: 'Hinglish', mr: 'Marathi', ta: 'Tamil', te: 'Telugu', bn: 'Bengali', gu: 'Gujarati', pa: 'Punjabi',
  kn: 'Kannada', ml: 'Malayalam', ur: 'Urdu', ne: 'Nepali',
};
